import { fas } from "@fortawesome/free-solid-svg-icons";

const iconNames = Object.values(fas)
  .filter((entry) => entry && typeof entry === "object" && entry.iconName)
  .map((entry) => entry.iconName);

const sortedUniqueIconNames = Array.from(new Set(iconNames)).sort((a, b) =>
  a.localeCompare(b)
);

export const getMenuIconNames = () => sortedUniqueIconNames;

export const buildMenuIconCatalogCsv = () => {
  const header = "icono,clase_css";
  const rows = sortedUniqueIconNames.map(
    (name) => `${name},fa-solid fa-${name}`
  );
  return [header, ...rows].join("\n");
};
